import { faMapMarker, faXmark } from '@fortawesome/free-solid-svg-icons'
import { GoogleMap, Marker, Polyline } from '@react-google-maps/api'
import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { calculoAreaCoord, getBoundsNoArray } from '../../../../../../../../services/Afins'
import ButtonCustom from '../../../../../../../../Components/ButtonCustom'
import { getPedLaboratorio, OsItensTypes } from '../../../../../../../../services/Laboratorio'
import { destroyAlert, loadingAlert } from '../../../../../../../../utils/alert'
import './styles.css'
import { LineDivider } from '../../../../../../../../Components/CustomUi/LineDivider'

interface PropsVisuMaps {
  open: boolean
  update: number
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const VisualizarMapaTabela: React.FC<PropsVisuMaps> = (props) => {
  const { open, update, setOpen } = props

  const [geoJson, setGeoJson] = useState<any>([])
  const [kmlAnalise, setKmlAnalise] = useState({})
  const [grupoAnalises, setGrupoAnalises] = useState([])
  const [malha, setMalha] = useState<any>([])
  const [map, setMap] = useState<google.maps.Map>()

  const [listLinha, setListLinha] = useState<google.maps.LatLngLiteral[]>([])
  const linha = () => {
    //@ts-ignore
    const polyline: google.maps.LatLngLiteral[] = kmlAnalise.coordenadas?.map((rec) => {
      return {
        lat: Number(rec.latitude),
        lng: Number(rec.longitude),
      }
    })
    setListLinha(polyline)
  }

  async function buscarAnalise() {
    loadingAlert({ msg: 'Carregando...', id: 'loading_outro' })
    const resp = await getPedLaboratorio(update)
    const dados = resp.data.itens[0]
    setKmlAnalise(dados.talhao_kml)
    setGrupoAnalises(dados.analises)
    setMalha(dados.malha_de_pontos)
    destroyAlert('loading_outro')
  }

  useEffect(() => {
    if (malha?.features) {
      linha()
      const dadosGeo = malha

      dadosGeo.features.forEach((data) => {
        data.color = '#ffffff'
      })

      dadosGeo.features.forEach((data) => { })
      setGeoJson(malha)
    }
  }, [malha])

  useEffect(() => {
    if (map) {
      const bounds = getBoundsNoArray(listLinha)
      if (!map.getBounds()?.intersects(bounds)) {
        map.fitBounds(bounds)
      }
    }
  }, [listLinha])

  useEffect(() => {
    if (update > 0) {
      buscarAnalise()
    }
  }, [update])

  return (
    <Modal
      forceRender
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      closable={true}
      className='modal-talhao'
      style={{ minHeight: '81vh', minWidth: '65%', top: 10 }}
      destroyOnClose
    >
      <div className='modal-header'>
        <h3>Visualizar pontos</h3>
      </div>
      <div className='modal_infos'>
        <div>
          <label>Área do talhão</label>
          <p>{calculoAreaCoord([listLinha])} ha</p>
        </div>
        <div>
          <label>Grid amostral</label>
          <p>{(calculoAreaCoord([listLinha]) / geoJson?.features?.length).toFixed(2)} ha/ponto</p>
        </div>
        <div>
          <label>Quantidade de pontos</label>
          <p>{geoJson?.features?.length}</p>
        </div>
      </div>
      <div style={{ display: 'flex', paddingLeft: '15px', paddingRight: '15px', paddingBottom: '15px' }}>
        <GoogleMap
          onLoad={setMap}
          options={{
            mapTypeId: 'satellite',
            mapTypeControl: false,
            streetViewControl: false,
            clickableIcons: true,
          }}
          mapContainerStyle={{
            width: '100%',
            height: '71vh',
            border: '2px solid #d9d9d9',
            borderRadius: '5px',
          }}
        >
          {geoJson?.features?.map((data) => {
            return (
              <>
                {/* @ts-ignore */}
                <Marker
                  icon={{
                    path: faMapMarker.icon[4] as string,
                    anchor: new window.google.maps.Point(190, 550),
                    fillColor: data.color,
                    fillOpacity: 1,
                    strokeWeight: 1,
                    strokeColor: '#ffffff',
                    scale: 0.055,
                    labelOrigin: new window.google.maps.Point(190, 220),
                  }}
                  animation={window.google.maps.Animation.DROP}
                  options={{
                    clickable: false,
                    draggable: false,
                  }}
                  label={{
                    className: 'color-marker-label',
                    text: parseInt(data.properties.NOME, 10).toString(),
                    fontSize: '11px',
                    fontWeight: 'bold',
                  }}
                  key={data.properties.INDICE}
                  position={{
                    lat: parseFloat(data.geometry.coordinates[1]),
                    lng: parseFloat(data.geometry.coordinates[0]),
                  }}
                />
              </>
            )
          })}
          <Polyline
            options={{
              path: listLinha,
              geodesic: true,
              strokeColor: '#00f75b',
              strokeOpacity: 1.0,
              strokeWeight: 4,
              zIndex: 0,
            }}
          />
        </GoogleMap>
      </div>
    </Modal>
  )
}
